import { SupplyShedAggregationType } from '@cibo/core'
import {
  GEOPOLITICAL,
  HUC10_SHAPE_SOURCE_LAYER,
  HUC12_SHAPE_SOURCE_LAYER,
  HUC2_SHAPE_SOURCE_LAYER,
  HUC4_SHAPE_SOURCE_LAYER,
  HUC6_SHAPE_SOURCE_LAYER,
  HUC8_SHAPE_SOURCE_LAYER,
  HUC_WATERSHED_SOURCE_ID,
} from '@cibo/mapgl'
import { MapboxGeoJSONFeature } from 'react-map-gl/dist/es5'

type ResourceDesription = {
  type: SupplyShedAggregationType
  idLength: number
  id: number
}

export type SupplyShedFeature = {
  feature: MapboxGeoJSONFeature
  type: SupplyShedAggregationType
}

const HUC_LAYER_FOR_ID_LENGTH: Record<number, string> = {
  2: HUC2_SHAPE_SOURCE_LAYER,
  4: HUC4_SHAPE_SOURCE_LAYER,
  6: HUC6_SHAPE_SOURCE_LAYER,
  8: HUC8_SHAPE_SOURCE_LAYER,
  10: HUC10_SHAPE_SOURCE_LAYER,
  12: HUC12_SHAPE_SOURCE_LAYER,
}

// We should not be parsing resourceIds but this seems to be the only way to
// find features to be hilighted by resourceId from the path.
export const UNSAFE_parseResourceId = (resourceId: string) => {
  const [prefix, idString] = resourceId.split(':')
  const idLength = idString?.length
  const id = parseInt(resourceId.split(':')[1], 10)

  if (prefix === 'fips') {
    if (idLength === 2) {
      return {
        type: 'state',
        idLength,
        id,
      } as ResourceDesription
    }
    if (idLength === 5) {
      return {
        type: 'county',
        idLength,
        id,
      } as ResourceDesription
    }
  }
  if (prefix === 'huc') {
    return {
      type: 'watershed',
      idLength,
      id,
    } as ResourceDesription
  }
}

export const supplyShedFeatureForResourceId = (resourceId: string) => {
  const resourceDescription = UNSAFE_parseResourceId(resourceId)
  if (!resourceDescription) {
    return
  }

  const { id, idLength, type } = resourceDescription

  switch (type) {
    case 'state':
      return {
        source: GEOPOLITICAL.SOURCE,
        sourceLayer: GEOPOLITICAL.STATES.SHAPES,
        id,
      } as MapboxGeoJSONFeature

    case 'county':
      return {
        source: GEOPOLITICAL.SOURCE,
        sourceLayer: GEOPOLITICAL.COUNTIES.SHAPES,
        id,
      } as MapboxGeoJSONFeature

    case 'watershed':
      return {
        source: HUC_WATERSHED_SOURCE_ID,
        sourceLayer: HUC_LAYER_FOR_ID_LENGTH[idLength],
        id,
      } as MapboxGeoJSONFeature
  }
}

//@todo use `resourceId` prop
export const resourceIdForSupplyShedFeature = ({ feature, type }: SupplyShedFeature) => {
  if (['state', 'county', 'fips'].includes(type)) {
    const featureId = feature.id

    const fips = `${featureId}`.padStart(`${featureId}`.length < 4 ? 2 : 5, '0')

    return `fips:${fips}`
  } else {
    return `huc:${feature.properties?.huc}`
  }
}
